import { useLocation } from 'react-router-dom';

type QueryParamKey = string | string[];

type QueryParamResult = string | string[] | null;

// Overload signatures
export function useGetQueryParams(param: string): string | null;
export function useGetQueryParams(params: string[]): (string | null)[];

export function useGetQueryParams(params: QueryParamKey): QueryParamResult {
  const { search } = useLocation();
  const searchParams = new URLSearchParams(search);

  if (typeof params === 'string') {
    return searchParams.get(params);
  }

  return params.map((param) => searchParams.get(param));
}
